import { useRouter } from 'next/router';

export const useIsGb = () => {
  const { slug } = useRouter().query;
  return slug === 'catering-london';
};
